import lang from '@/lang'
import { AE, AI, IE, RE, RI, SE, SI } from '@/class/cargo/model/parameters/SystemConstants'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { deepClone } from '@/utils/index'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

// 基本
export const ROUTE_NAME_TAB_BOOKING = 'tabBooking'
export const ROUTE_NAME_TAB_BOOKING_FCL = 'tabBookingFCL'
export const ROUTE_NAME_TAB_BUYER_CONSOLE_FCL_BOOKING_MASTER = 'tabBuyerConsoleFclBookingMaster'
export const ROUTE_NAME_TAB_BOOKING_MASTER = 'tabBookingMaster'
// 美国清关
export const ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE = 'tabUsCustomsClearance'
export const ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE_MASTER = 'tabUsCustomsClearanceMaster'
// 预配信息
export const ROUTE_NAME_TAB_PRE_PLAN_BOOKING = 'tabPrePlanBooking'
export const ROUTE_NAME_TAB_PRE_PLAN_BOOKING_LCL = 'tabPrePlanBookingLcl'
// MBL/MBL拆单/MBL并单
export const ROUTE_NAME_TAB_MBL = 'tabMBL'
export const ROUTE_NAME_TAB_MBL2 = 'tabMBL2'
// HBL/HBL拆单/HBL并单
export const ROUTE_NAME_TAB_HBL = 'tabHBL'
export const ROUTE_NAME_TAB_HBL2 = 'tabHBL2'
// 装箱信息
export const ROUTE_NAME_TAB_CONTAINER = 'tabContainer'
export const ROUTE_NAME_TAB_LCL_CONTAINER = 'tabLclContainer'
export const ROUTE_NAME_TAB_BUYER_CONSOLE_FCL_CONTAINER = 'tabBuyerConsoleFclContainer'
// 货物明细
export const ROUTE_NAME_TAB_TRADE_DETAIL = 'tabTradeDetail'
export const ROUTE_NAME_FBA_GOODS_DETAIL = 'fbaGoodsDetail'
// 进口操作
export const ROUTE_NAME_BASIC_TAB = 'basicTab'
export const ROUTE_NAME_MASTER_BASIC_TAB = 'masterBasicTab'
// 装板信息
export const ROUTE_NAME_TAB_UNIT_LOAD_DEVICE = 'tabUnitLoadDevice'
export const ROUTE_NAME_TAB_LCL_UNIT_LOAD_DEVICE = 'tabLclUnitLoadDevice'
// 综合物流-集卡拖车-基本页签
export const ROUTE_NAME_TAB_GATHERING_TRAILER_BASE = 'tabGatheringTrailerBase'
export const ROUTE_NAME_TAB_LESS_THAN_CARLOAD_BASE = 'tabLessThanCarloadBase'

const jumpMap = new Map([
  // 海出
  [SE.code, [
    {
      // 订舱预审
      name: lang.t('CargoMsg.Cargo_BookingPreAudit'),
      routeName: 'BookingVerify', // 跳转使用
      path: 'BookingVerify', // 构建树形结构使用
      roles: ['module_fmVerify', 'report_fmVerify', 'role_query_fmVerify'],
      tabs: [
        {
          // 基本
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_BOOKING, // 根据主小票、整拼类型跳转 tabBookingFCL、tabBookingMaster
          path: 'BookingVerify,tabBooking'
        },
        {
          // 订舱
          name: lang.t('SeaExport.Booking'),
          routeName: 'tabVesselEq',
          path: 'BookingVerify,tabVesselEq'
        },
        {
          // 美国清关
          name: lang.t('queryJob.UsCustomsClearance'),
          routeName: ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE, // tabUsCustomsClearance、tabUsCustomsClearanceMaster
          path: 'BookingVerify,tabUsCustomsClearance'
        },
        {
          // MBL/MBL拆单/MBL并单
          name: 'MBL/MBL' + lang.t('CargoMsg.Cargo_SplitBL') + '/MBL' + lang.t('SeaExport.MergeAndSingle'),
          routeName: ROUTE_NAME_TAB_MBL, // tabMBL、tabMBL2、
          path: 'BookingVerify,tabMBL'
        },
        {
          // HBL/HBL拆单/HBL并单
          name: 'HBL/HBL' + lang.t('CargoMsg.Cargo_SplitBL') + '/HBL' + lang.t('SeaExport.MergeAndSingle'),
          routeName: ROUTE_NAME_TAB_HBL, // tabHBL、tabHBL2
          path: 'BookingVerify,tabHBL'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'BookingVerify,tabWarehouse'
        },
        {
          // 目的港派车
          name: lang.t('SeaExport.DispatchVehiclesAtDestination'),
          routeName: 'tabDischargingTrucking',
          path: 'BookingVerify,tabDischargingTrucking'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer
          path: 'BookingVerify,tabContainer'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'BookingVerify,tabCharges'
        }
      ]
    },
    {
      // 海运订舱
      name: lang.t('CargoMsg.Cargo_SeaBooking'),
      routeName: 'SeaBooking', // 跳转使用
      path: 'SeaBooking', // 构建树形结构使用
      tabs: [
        {
          // 基本
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_BOOKING, // 根据主小票、整拼类型跳转 tabBookingFCL、tabBookingMaster、tabBuyerConsoleFclBookingMaster
          path: 'SeaBooking,tabBooking'
        },
        {
          // 订舱
          name: lang.t('SeaExport.Booking'),
          routeName: 'tabVesselEq',
          path: 'SeaBooking,tabVesselEq'
        },
        {
          // 美国清关
          name: lang.t('queryJob.UsCustomsClearance'),
          routeName: ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE, // tabUsCustomsClearance、tabUsCustomsClearanceMaster
          path: 'SeaBooking,tabUsCustomsClearance'
        },
        {
          // 预配信息
          name: lang.t('SeaExport.prePlanBooking'),
          routeName: ROUTE_NAME_TAB_PRE_PLAN_BOOKING, // tabPrePlanBooking、tabPrePlanBookingLcl
          path: 'SeaBooking,tabPrePlanBooking'
        },
        {
          // VGM
          name: 'VGM',
          routeName: 'tabVGM',
          path: 'SeaBooking,tabVGM'
        },
        {
          // MBL/MBL拆单/MBL并单
          name: 'MBL/MBL' + lang.t('CargoMsg.Cargo_SplitBL') + '/MBL' + lang.t('SeaExport.MergeAndSingle'),
          routeName: ROUTE_NAME_TAB_MBL, // tabMBL、tabMBL2、
          path: 'SeaBooking,tabMBL'
        },
        {
          // HBL/HBL拆单/HBL并单
          name: 'HBL/HBL' + lang.t('CargoMsg.Cargo_SplitBL') + '/HBL' + lang.t('SeaExport.MergeAndSingle'),
          routeName: ROUTE_NAME_TAB_HBL, // tabHBL、tabHBL2
          path: 'SeaBooking,tabHBL'
        },
        {
          // 前置仓
          name: lang.t('SeaExport.BackUpWarehouse'),
          routeName: 'tabBackUpWarehouse',
          path: 'SeaBooking,tabBackUpWarehouse'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'SeaBooking,tabWarehouse'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer、tabBuyerConsoleFclContainer
          path: 'SeaBooking,tabContainer'
        },
        {
          // 客户门点
          name: lang.t('SeaExport.Trucking'),
          routeName: 'tabTruckingForSe',
          path: 'SeaBooking,tabTruckingForSe'
        },
        {
          // 目的港派车
          name: lang.t('SeaExport.DispatchVehiclesAtDestination'),
          routeName: 'tabDischargingTrucking',
          path: 'SeaBooking,tabDischargingTrucking'
        },
        {
          // 报关
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'SeaBooking,tabCustomsInfo'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'SeaBooking,tabInsure'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL, // tabTradeDetail、fbaGoodsDetail
          path: 'SeaBooking,tabTradeDetail'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'SeaBooking,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'SeaBooking,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'SeaBooking,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'SeaBooking,tabAdvanceCharge'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'SeaBooking,tabFile'
        },
        {
          // 特殊货物信息
          name: lang.t('SpecialGoods.label'),
          routeName: 'tabSpecialGoods',
          path: 'SeaBooking,tabSpecialGoods'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'SeaBooking,tabFileHistory'
        }
      ]
    },
    {
      // 舱位管理
      name: lang.t('CargoMsg.Cargo_CabinManagement'),
      routeName: 'CabinManagement', // 跳转使用
      path: 'CabinManagement', // 构建树形结构使用
      roles: ['module_cabinManagement', 'report_cabinManagement', 'role_query_cabinManagement'],
      tabs: [
        {
          // 舱位管理列表页
          name: lang.t('SeaExport.BookingManagementListPage'),
          routeName: 'list',
          path: 'CabinManagement,list'
        }
      ]
    }
  ]],
  // 海进
  [SI.code, [
    {
      // 预报
      name: lang.t('CargoMsg.Cargo_Prediction'),
      routeName: 'SiPrediction',
      path: 'SiPrediction',
      roles: ['module_SIPREALERT', 'report_SIPREALERT', 'role_query_SIPREALERT'],
      tabs: [
        {
          // 进口操作
          name: lang.t('SeaExport.ImportOperation'),
          routeName: ROUTE_NAME_BASIC_TAB, // basicTab、masterBasicTab
          path: 'SiPrediction,basicTab'
        },
        {
          // 到港信息
          name: lang.t('SeaExport.ArrivalInformation'),
          routeName: 'tabArrivalInformation',
          path: 'SiPrediction,tabArrivalInformation'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'SiPrediction,tabCharges'
        },
        {
          // MBL
          name: 'MBL',
          routeName: ROUTE_NAME_TAB_MBL, // tabMBL
          path: 'SiPrediction,tabMBL'
        },
        {
          // HBL
          name: 'HBL',
          routeName: ROUTE_NAME_TAB_HBL, // tabHBL
          path: 'SiPrediction,tabHBL'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer
          path: 'SiPrediction,tabContainer'
        }
      ]
    },
    {
      // 海运操作
      name: lang.t('route.seaImportBooking'),
      routeName: 'SiBooking',
      path: 'SiBooking',
      tabs: [
        {
          // 进口操作
          name: lang.t('SeaExport.ImportOperation'),
          routeName: ROUTE_NAME_BASIC_TAB, // basicTab、masterBasicTab
          path: 'SiBooking,basicTab'
        },
        {
          // 到港信息
          name: lang.t('SeaExport.ArrivalInformation'),
          routeName: 'tabArrivalInformation',
          path: 'SiBooking,tabArrivalInformation'
        },
        {
          // 美国清关
          name: lang.t('queryJob.UsCustomsClearance'),
          routeName: ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE, // tabUsCustomsClearance、tabUsCustomsClearanceMaster
          path: 'SiBooking,tabUsCustomsClearance'
        },
        {
          // MBL/MBL拆单/MBL并单
          name: 'MBL/MBL' + lang.t('CargoMsg.Cargo_SplitBL') + '/MBL' + lang.t('SeaExport.MergeAndSingle'),
          routeName: ROUTE_NAME_TAB_MBL, // tabMBL、tabMBL2、
          path: 'SiBooking,tabMBL'
        },
        {
          // HBL/HBL拆单/HBL并单
          name: 'HBL/HBL' + lang.t('CargoMsg.Cargo_SplitBL') + '/HBL' + lang.t('SeaExport.MergeAndSingle'),
          routeName: ROUTE_NAME_TAB_HBL, // tabHBL、tabHBL2
          path: 'SiBooking,tabHBL'
        },
        {
          // 本地服务
          name: lang.t('SeaExport.LocalService'),
          routeName: 'tabLocalService',
          path: 'SiBooking,tabLocalService'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'SiBooking,tabInsure'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL,
          path: 'SiBooking,tabTradeDetail'
        },
        {
          // 贸易
          name: lang.t('SeaExport.TradeCommission'),
          routeName: 'tabTradeCommission',
          path: 'SiBooking,tabTradeCommission'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer
          path: 'SiBooking,tabContainer'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'SiBooking,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'SiBooking,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'SiBooking,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'SiBooking,tabAdvanceCharge'
        },
        {
          // 报关
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'SiBooking,tabCustomsInfo'
        },
        {
          // 进口舱单
          name: lang.t('SeaImport.ImportManifest'),
          routeName: 'tabImportManifest',
          path: 'SiBooking,tabImportManifest'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'SiBooking,tabFile'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'SiBooking,tabFileHistory'
        }
      ]
    }
  ]],
  // 空出
  [AE.code, [
    {
      // 订单预审
      name: lang.t('route.preOrder'),
      routeName: 'AeBookingVerify',
      path: 'AeBookingVerify',
      roles: ['module_AEPreVerify', 'report_AEPreVerify', 'role_query_AEPreVerify'],
      tabs: [
        {
          // 基本
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_BASIC_TAB, // basicTab、masterBasicTab
          path: 'AeBookingVerify,basicTab'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'AeBookingVerify,tabCharges'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'AeBookingVerify,tabFileHistory'
        }
      ]
    },
    {
      // 空运订舱
      name: lang.t('route.airExportBooking'),
      routeName: 'AeBooking',
      path: 'AeBooking',
      tabs: [
        {
          // 基本
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_BASIC_TAB, // basicTab、masterBasicTab
          path: 'AeBooking,basicTab'
        },
        {
          // 订舱
          name: lang.t('CargoMsg.Cargo_Booking'),
          routeName: 'tabAirVesselEq',
          path: 'AeBooking,tabAirVesselEq'
        },
        {
          // 航运追踪
          name: lang.t('SeaExport.AirDataTracking'),
          routeName: 'tabAirDataTracking',
          path: 'AeBooking,tabAirDataTracking'
        },
        {
          // 美国清关
          name: lang.t('queryJob.UsCustomsClearance'),
          routeName: ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE, // tabUsCustomsClearance、tabUsCustomsClearanceMaster
          path: 'AeBooking,tabUsCustomsClearance'
        },
        {
          // MAWB
          name: 'MAWB',
          routeName: 'tabMAWB',
          path: 'AeBooking,tabMAWB'
        },
        {
          // HAWB
          name: 'HAWB',
          routeName: 'tabHAWB',
          path: 'AeBooking,tabHAWB'
        },
        {
          // 形式分单
          name: lang.t('SeaExport.FormalHbl'),
          routeName: 'tabSubBill',
          path: 'AeBooking,tabSubBill'
        },
        {
          // 装板信息
          name: lang.t('CargoMsg.Cargo_MountingInformation'),
          routeName: ROUTE_NAME_TAB_UNIT_LOAD_DEVICE, // tabUnitLoadDevice、tabLclUnitLoadDevice
          path: 'AeBooking,tabUnitLoadDevice'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL, // tabTradeDetail、fbaGoodsDetail
          path: 'AeBooking,tabTradeDetail'
        },
        {
          // 贸易
          name: lang.t('SeaExport.TradeCommission'),
          routeName: 'tabTradeCommission',
          path: 'AeBooking,tabTradeCommission'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'AeBooking,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'AeBooking,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'AeBooking,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'AeBooking,tabAdvanceCharge'
        },
        {
          // 报关/续程
          name: lang.t('SeaExport.CustomsDeclarationOnward'),
          routeName: 'tabCustomsInfo',
          path: 'AeBooking,tabCustomsInfo'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'AeBooking,tabInsure'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'AeBooking,tabFile'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouseTrucking',
          path: 'AeBooking,tabWarehouseTrucking'
        },
        {
          // 目的港派车
          name: lang.t('SeaExport.DispatchVehiclesAtDestination'),
          routeName: 'tabDischargingTrucking',
          path: 'AeBooking,tabDischargingTrucking'
        },
        {
          // 货物信息
          name: lang.t('SeaExport.CargoInfo'),
          routeName: 'tabWarehouse',
          path: 'AeBooking,tabWarehouse'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'AeBooking,tabFileHistory'
        }
      ]
    }
  ]],
  // 空进
  [AI.code, [
    {
      // 预报
      name: lang.t('CargoMsg.Cargo_Prediction'),
      routeName: 'AiOrder',
      path: 'AiOrder',
      roles: ['module_Order', 'report_Order', 'role_query_Order'],
      tabs: [
        {
          // 空运操作
          name: lang.t('CargoMsg.Cargo_Booking'),
          routeName: ROUTE_NAME_TAB_BOOKING, // tabBookingFCL、tabBookingMaster
          path: 'AiOrder,tabBooking'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'AiOrder,tabCharges'
        }
      ]
    },
    {
      // 空运操作
      name: lang.t('route.airImportBooking'),
      routeName: 'AiBooking',
      path: 'AiBooking',
      tabs: [
        {
          // 空运操作
          name: lang.t('SeaExport.AirOperation') + '/' + lang.t('SeaExport.MblInfo'),
          routeName: ROUTE_NAME_TAB_BOOKING, // tabBookingFCL、tabBookingMaster
          path: 'AiBooking,tabBooking'
        },
        {
          // 美国清关
          name: lang.t('queryJob.UsCustomsClearance'),
          routeName: ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE, // tabUsCustomsClearance、tabUsCustomsClearanceMaster
          path: 'AiBooking,tabUsCustomsClearance'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL,
          path: 'AiBooking,tabTradeDetail'
        },
        {
          // 贸易
          name: lang.t('SeaExport.TradeCommission'),
          routeName: 'tabTradeCommission',
          path: 'AiBooking,tabTradeCommission'
        },
        {
          // 分单信息
          name: lang.t('SeaExport.HblInfo'),
          routeName: 'tabHbl',
          path: 'AiBooking,tabHbl'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'AiBooking,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'AiBooking,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'AiBooking,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'AiBooking,tabAdvanceCharge'
        },
        {
          // 报关页签
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'AiBooking,tabCustomsInfo'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'AiBooking,tabInsure'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'AiBooking,tabFile'
        },
        {
          // 本地服务
          name: lang.t('SeaExport.LocalService'),
          routeName: 'tabLocalService',
          path: 'AiBooking,tabLocalService'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'AiBooking,tabFileHistory'
        }
      ]
    }
  ]],
  // 铁出
  [RE.code, [
    {
      // 订舱预审
      name: lang.t('CargoMsg.Cargo_BookingPreAudit'),
      routeName: 'ReBookingVerify',
      path: 'ReBookingVerify',
      roles: ['module_RailwayBookingVerify', 'report_RailwayBookingVerify', 'role_query_RailwayBookingVerify'],
      tabs: [
        {
          // 基本页签
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_BOOKING, // tabBookingFCL、tabBookingMaster
          path: 'ReBookingVerify,tabBooking'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'ReBookingVerify,tabWarehouse'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer
          path: 'ReBookingVerify,tabContainer'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL, // tabTradeDetail
          path: 'ReBookingVerify,tabTradeDetail'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'ReBookingVerify,tabCustomsInfo'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'ReBookingVerify,tabCharges'
        }
      ]
    },
    {
      // 铁路操作
      name: lang.t('CargoMsg.Cargo_RailwayOperate'),
      routeName: 'ReBooking',
      path: 'ReBooking',
      tabs: [
        {
          // 基本页签
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_BOOKING, // tabBookingFCL、tabBookingMaster
          path: 'ReBooking,tabBooking'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'ReBooking,tabWarehouse'
        },
        {
          // 客户门点
          name: lang.t('SeaExport.Trucking'),
          routeName: 'tabTrucking',
          path: 'ReBooking,tabTrucking'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer
          path: 'ReBooking,tabContainer'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL, // tabTradeDetail、fbaGoodsDetail
          path: 'ReBooking,tabTradeDetail'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'ReBooking,tabInsure'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'ReBooking,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'ReBooking,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'ReBooking,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'ReBooking,tabAdvanceCharge'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'ReBooking,tabFileHistory'
        }
      ]
    }
  ]],
  // 铁进
  [RI.code, [
    {
      // 订舱预审
      name: lang.t('CargoMsg.Cargo_BookingPreAudit'),
      routeName: 'ReBookingVerify',
      path: 'RiBookingVerify',
      roles: ['module_RailwayBookingVerify', 'report_RailwayBookingVerify', 'role_query_RailwayBookingVerify'],
      tabs: [
        {
          // 基本页签
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_BOOKING, // tabBookingFCL、tabBookingMaster
          path: 'RiBookingVerify,tabBooking'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'RiBookingVerify,tabWarehouse'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer
          path: 'RiBookingVerify,tabContainer'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL, // tabTradeDetail
          path: 'RiBookingVerify,tabTradeDetail'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'RiBookingVerify,tabCustomsInfo'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'RiBookingVerify,tabCharges'
        }
      ]
    },
    {
      // 铁路操作
      name: lang.t('CargoMsg.Cargo_RailwayOperate'),
      routeName: 'ReBooking',
      path: 'ReBooking',
      tabs: [
        {
          // 基本页签
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_BOOKING, // tabBookingFCL、tabBookingMaster
          path: 'ReBooking,tabBooking'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'ReBooking,tabWarehouse'
        },
        {
          // 客户门点
          name: lang.t('SeaExport.Trucking'),
          routeName: 'tabTrucking',
          path: 'ReBooking,tabTrucking'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER, // tabContainer、tabLclContainer
          path: 'ReBooking,tabContainer'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL, // tabTradeDetail、fbaGoodsDetail
          path: 'ReBooking,tabTradeDetail'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'ReBooking,tabInsure'
        },
        {
          // 费用页签
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'ReBooking,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'ReBooking,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'ReBooking,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'ReBooking,tabAdvanceCharge'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'ReBooking,tabFileHistory'
        }
      ]
    }
  ]],
  // 综合物流
  [IE.code, [
    {
      // 集卡拖车
      name: lang.t('CargoMsg.Cargo_TruckTrailer'),
      routeName: 'IEBooking',
      path: 'IEBooking_TT',
      tabs: [
        {
          // 基本页签
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_GATHERING_TRAILER_BASE, // tabGatheringTrailerBase、tabLessThanCarloadBase
          path: 'IEBooking_TT,tabGatheringTrailerBase'
        },
        {
          // 集卡拖车
          name: lang.t('SeaExport.GatheringTrailer'),
          routeName: 'tabGatheringTrailer',
          path: 'IEBooking_TT,tabGatheringTrailer'
        },
        {
          // 装箱信息
          name: lang.t('SeaExport.ContainerInfo'),
          routeName: ROUTE_NAME_TAB_CONTAINER,
          path: 'IEBooking_TT,tabContainer'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'IEBooking_TT,tabWarehouse'
        },
        {
          // 货物信息
          name: lang.t('SeaExport.CargoInfo'),
          routeName: 'tabWarehouseIn',
          path: 'IEBooking_TT,tabWarehouseIn'
        },
        {
          // 报关
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'IEBooking_TT,tabCustomsInfo'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'IEBooking_TT,tabInsure'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL,
          path: 'IEBooking_TT,tabTradeDetail'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'IEBooking_TT,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'IEBooking_TT,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'IEBooking_TT,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'IEBooking_TT,tabAdvanceCharge'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'IEBooking_TT,tabFile'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'IEBooking_TT,tabFileHistory'
        }
      ]
    },
    {
      // 整车/零担
      name: lang.t('CargoMsg.Cargo_WholeVehicleAndLessThanCarload'),
      routeName: 'IEBooking',
      path: 'IEBooking_CL',
      tabs: [
        {
          // 基本页签
          name: lang.t('SeaExport.Basic'),
          routeName: ROUTE_NAME_TAB_GATHERING_TRAILER_BASE, // tabGatheringTrailerBase、tabLessThanCarloadBase
          path: 'IEBooking_CL,tabGatheringTrailerBase'
        },
        {
          // 整车零担
          name: lang.t('SeaExport.WholeVehicleLessThanCarload'),
          routeName: 'tabLessThanCarload',
          path: 'IEBooking_CL,tabLessThanCarload'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'IEBooking_CL,tabWarehouse'
        },
        {
          // 报关
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'IEBooking_CL,tabCustomsInfo'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'IEBooking_CL,tabInsure'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL,
          path: 'IEBooking_CL,tabTradeDetail'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'IEBooking_CL,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'IEBooking_CL,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'IEBooking_CL,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'IEBooking_CL,tabAdvanceCharge'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'IEBooking_CL,tabFile'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'IEBooking_CL,tabFileHistory'
        }
      ]
    },
    {
      // 国际卡航
      name: lang.t('CargoMsg.Cargo_IC'),
      routeName: 'IEBooking',
      path: 'IEBooking_IC',
      tabs: [
        {
          // 国际卡航
          name: lang.t('CargoMsg.Cargo_IC'),
          routeName: 'tabInternationalCard',
          path: 'IEBooking_IC,tabInternationalCard'
        },
        {
          // 订舱页签
          name: lang.t('CargoMsg.Cargo_Booking'),
          routeName: 'tabOrderCar',
          path: 'IEBooking_IC,tabOrderCar'
        },
        {
          // 门点信息
          name: lang.t('Partners.doorInformation'),
          routeName: 'tabDoorInformation',
          path: 'IEBooking_IC,tabDoorInformation'
        },
        {
          // 目的地派送
          name: lang.t('CargoMsg.Cargo_DestinationDelivery'),
          routeName: 'tabDestinationDelivery',
          path: 'IEBooking_IC,tabDestinationDelivery'
        },
        {
          // 仓库内装
          name: lang.t('SeaExport.WarehouseLoading'),
          routeName: 'tabWarehouse',
          path: 'IEBooking_IC,tabWarehouse'
        },
        {
          // 货物信息
          name: lang.t('SeaExport.CargoInfo'),
          routeName: 'tabWarehouseIn',
          path: 'IEBooking_IC,tabWarehouseIn'
        },
        {
          // 报关
          name: lang.t('SeaExport.CustomsDeclaration'),
          routeName: 'tabCustomsInfo',
          path: 'IEBooking_IC,tabCustomsInfo'
        },
        {
          // 保险
          name: lang.t('SeaExport.InsureInfo'),
          routeName: 'tabInsure',
          path: 'IEBooking_IC,tabInsure'
        },
        {
          // 货物明细
          name: lang.t('SeaExport.TradeDetail'),
          routeName: ROUTE_NAME_TAB_TRADE_DETAIL,
          path: 'IEBooking_IC,tabTradeDetail'
        },
        {
          // 费用
          name: lang.t('SeaExport.Charge'),
          routeName: 'tabCharges',
          path: 'IEBooking_IC,tabCharges'
        },
        {
          // 国内账单
          name: lang.t('SeaExport.InternalBillInfo'),
          routeName: 'tabInternalBill',
          path: 'IEBooking_IC,tabInternalBill'
        },
        {
          // 国外账单
          name: lang.t('SeaExport.OverseaBillInfo'),
          routeName: 'tabOverseaBill',
          path: 'IEBooking_IC,tabOverseaBill'
        },
        {
          // 代收垫付
          name: lang.t('SeaExport.AdvanceChargeInfo'),
          routeName: 'tabAdvanceCharge',
          path: 'IEBooking_IC,tabAdvanceCharge'
        },
        {
          // 单证流转
          name: lang.t('SeaExport.DocumentCirculation'),
          routeName: 'tabFile',
          path: 'IEBooking_IC,tabFile'
        },
        {
          // 文件历史
          name: lang.t('SeaExport.FileHistory'),
          routeName: 'tabFileHistory',
          path: 'IEBooking_IC,tabFileHistory'
        }
      ]
    }
  ]]
])

export class JumpUtil {
  /**
   * 获取树形结构数据
   * @param lob
   * @returns {[{path: string, name: VueI18n.TranslateResult, tabs: [{path: string, name: VueI18n.TranslateResult, routeName: string},{path: string, name: VueI18n.TranslateResult, routeName: string},{path: string, name: VueI18n.TranslateResult, routeName: string},{path: string, name: VueI18n.TranslateResult, routeName: string},{path: string, name: string, routeName: string},null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null], routeName: string}]}
   */
  static getJumpTree(lob) {
    const jumpTree = deepClone(jumpMap.get(lob))
    jumpTree.forEach(jump => {
      jump.type = 1
      jump.tabs.forEach(tab => {
        tab.type = 2
        jumpTree.push(tab)
      })
    })
    return jumpTree
  }

  /**
   * 获取跳转数据
   * @param path
   * @param job
   * @returns {{tabRouteName: string, routeName: string}}
   */
  static getJumpByPath(path, job) {
    const jumpTree = jumpMap.get(job.lob)
    const oneLevelPath = path.split(',')[0]
    const res = {
      routeName: '',
      tabRouteName: ''
    }
    jumpTree.forEach(jump => {
      if (jump.path === oneLevelPath) {
        // 路由名称
        res.routeName = jump.routeName
        // 权限
        res.roles = jump.roles
        // tab路由名称
        const tab = jump.tabs.find(tab => tab.path === path)
        if (tab) {
          // 基本
          if (ROUTE_NAME_TAB_BOOKING === tab.routeName) {
            if (job.lob === SE.code) {
              if (job.masterFlag) {
                if (jump.path === 'SeaBooking' && job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
                  res.tabRouteName = ROUTE_NAME_TAB_BUYER_CONSOLE_FCL_BOOKING_MASTER
                } else {
                  res.tabRouteName = ROUTE_NAME_TAB_BOOKING_MASTER
                }
              } else {
                res.tabRouteName = ROUTE_NAME_TAB_BOOKING_FCL
              }
            } else if (job.lob === AI.code || job.lob === RE.code || job.lob === RI.code) {
              if (job.masterFlag) {
                res.tabRouteName = ROUTE_NAME_TAB_BOOKING_MASTER
              } else {
                res.tabRouteName = ROUTE_NAME_TAB_BOOKING_FCL
              }
            }
          }
          // 美国清关
          else if (ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE === tab.routeName) {
            if (job.masterFlag) {
              res.tabRouteName = ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE_MASTER
            } else {
              res.tabRouteName = ROUTE_NAME_TAB_US_CUSTOMS_CLEARANCE
            }
          }
          // 预配信息
          else if (ROUTE_NAME_TAB_PRE_PLAN_BOOKING === tab.routeName) {
            if (job.masterFlag) {
              res.tabRouteName = ROUTE_NAME_TAB_PRE_PLAN_BOOKING_LCL
            } else {
              res.tabRouteName = ROUTE_NAME_TAB_PRE_PLAN_BOOKING
            }
          }
          // MBL/MBL拆单/MBL并单
          else if (ROUTE_NAME_TAB_MBL === tab.routeName) {
            if (jump.path === 'SiPrediction') {
              res.tabRouteName = ROUTE_NAME_TAB_MBL
            } else {
              if (job.typeMBL === BillType.SPLIT_BILL_TYPE.code || job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
                res.tabRouteName = ROUTE_NAME_TAB_MBL2
              } else {
                res.tabRouteName = ROUTE_NAME_TAB_MBL
              }
              console.log('res.tabRouteName', res.tabRouteName)
            }
          }
          // HBL/HBL拆单/HBL并单
          else if (ROUTE_NAME_TAB_HBL === tab.routeName) {
            if (job.lob === AI.code) {
              res.tabRouteName = ROUTE_NAME_TAB_HBL
            } else {
              if (job.typeHBL === BillType.SPLIT_BILL_TYPE.code || job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
                res.tabRouteName = ROUTE_NAME_TAB_HBL2
              } else {
                res.tabRouteName = ROUTE_NAME_TAB_HBL
              }
            }
          }
          // 装箱信息
          else if (ROUTE_NAME_TAB_CONTAINER === tab.routeName) {
            if (job.lob === SE.code) {
              if (job.masterFlag) {
                if (jump.path === 'SeaBooking' && job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
                  res.tabRouteName = ROUTE_NAME_TAB_BUYER_CONSOLE_FCL_CONTAINER
                } else {
                  res.tabRouteName = ROUTE_NAME_TAB_LCL_CONTAINER
                }
              } else {
                res.tabRouteName = ROUTE_NAME_TAB_CONTAINER
              }
            } else if (job.lob === IE.code) {
              res.tabRouteName = ROUTE_NAME_TAB_CONTAINER
            } else if (jump.path === 'SiPrediction') {
              res.tabRouteName = ROUTE_NAME_TAB_CONTAINER
            } else {
              if (job.masterFlag) {
                res.tabRouteName = ROUTE_NAME_TAB_LCL_CONTAINER
              } else {
                res.tabRouteName = ROUTE_NAME_TAB_CONTAINER
              }
            }
          }
          // 货物明细
          else if (ROUTE_NAME_TAB_TRADE_DETAIL === tab.routeName) {
            if (job.fba) {
              res.tabRouteName = ROUTE_NAME_FBA_GOODS_DETAIL
            } else {
              res.tabRouteName = ROUTE_NAME_TAB_TRADE_DETAIL
            }
          }
          // 进口操作
          else if (ROUTE_NAME_TAB_TRADE_DETAIL === tab.routeName) {
            if (job.masterFlag) {
              res.tabRouteName = ROUTE_NAME_MASTER_BASIC_TAB
            } else {
              res.tabRouteName = ROUTE_NAME_BASIC_TAB
            }
          }
          // 装板信息
          else if (ROUTE_NAME_TAB_UNIT_LOAD_DEVICE === tab.routeName) {
            if (job.masterFlag) {
              res.tabRouteName = ROUTE_NAME_TAB_LCL_UNIT_LOAD_DEVICE
            } else {
              res.tabRouteName = ROUTE_NAME_TAB_UNIT_LOAD_DEVICE
            }
          }
          // 综合物流-集卡拖车/整车零担-基本页签
          else if (ROUTE_NAME_TAB_GATHERING_TRAILER_BASE === tab.routeName) {
            if (job.containerLoadType === ContainerLoadType.STUFFY_TT.code) {
              res.tabRouteName = ROUTE_NAME_TAB_GATHERING_TRAILER_BASE
            } else if (job.containerLoadType === ContainerLoadType.STUFFY_CL.code) {
              res.tabRouteName = ROUTE_NAME_TAB_LESS_THAN_CARLOAD_BASE
            }
          } else {
            res.tabRouteName = tab.routeName
          }
        }
      }
    })
    return res
  }

  /**
   * 跳转到具体tab
   * @param advancedQuery
   * @param filter
   * @param params
   * @param view
   * @param detailRefName
   */
  static jumpToTab(advancedQuery, filter, params, view, detailRefName = 'bookingWorkspace') {
    filter.appendQuery = false
    filter.branchId = view.$store.getters.currentOfficeId
    filter.conditions = filter.conditions || []
    filter.conditions.push(
      new AdvancedSearchOption(null, 'job.JOB_NO', params.jobNos, OPERATOR_IN.code).formatObj2Json()
    )
    filter.pageNum = 1
    filter.pageSize = params.jobNos.length
    view.view = 'detail'
    view.$refs[detailRefName].activeTabName = params.activeTabName || ''
    const editState = params.editState || false
    const loading = getLoading4Cxt(view)
    advancedQuery(filter).then(async res => {
      if (!res.data.list) {
        res.data = res.data.pageInfo
      }
      const rowData = res.data.list
      if (rowData && rowData.length > 0) {
        rowData.forEach(row => {
          // 为了使 usCustomsClearanceListFilter 计算属性能触发计算
          row.usCustomsClearanceList = []
        })
        rowData.sort((rowA, rowB) => {
          if (rowA.jobNo < rowB.jobNo) {
            return -1
          } else {
            return 1
          }
        })
        view.$refs[detailRefName].saveJobNos = []
        view.$refs[detailRefName].removedJobNos = []
        const index = rowData.findIndex(p => p.jobNo === params.jobNo)
        if (index >= 0) {
          const row = rowData[index]
          const action = editState && (row.jobState === 0 || row.jobState === -1) && !JobUtils.isBlockJob(row) ? 'edit' : 'look'
          await view.$refs[detailRefName].onShow(action, rowData, row)
          if (params.activeTabName !== view.$refs[detailRefName].activeTabName) {
            view.$message.error(view.$t('CargoMsg.Cargo_TabNotExistTip'))
          }
        } else {
          const row = rowData[0]
          // const action = editState && (row.jobState === 0 || row.jobState === -1) && !JobUtils.isBlockJob(row) ? 'edit' : 'look'
          await view.$refs[detailRefName].onShow('look', rowData, row)
          view.$message.error(view.$t('CargoMsg.Cargo_JobNotFound', [params.jobNo]))
        }
        console.log('params.activeTabName:', params.activeTabName)
        console.log('view.$refs[detailRefName].activeTabName:', view.$refs[detailRefName].activeTabName)
      } else {
        view.$message.error(view.$t('Message.NoRecordMeetTheConditions'))
        view.$refs[detailRefName].goBack()
      }
    }).finally(() => {
      loading.close()
      delete params.jobNo
      delete params.jobNos
      delete params.activeTabName
      delete params.editState
    })
  }
}
